// Shared Tailwind arbitrary-selector rules for rendering sanitized agent
// HTML (BC-23). Used by the Tiptap composer (typing surface), MessageBubble
// (chat history) and the /design Formatting demo. Only the structural rules
// live here — each surface layers its own color tokens on top (the editor
// uses text-foreground on bg-muted; the agent bubble uses text-current on
// bg-primary; the visitor bubble uses text-current on bg-muted).

export const RICH_PROSE_BASE = [
  '[&_p]:my-1 [&_p:first-child]:mt-0 [&_p:last-child]:mb-0',
  '[&_strong]:font-semibold [&_em]:italic',
  '[&_code]:px-1 [&_code]:py-0.5 [&_code]:rounded [&_code]:text-[0.85em] [&_code]:font-mono',
  '[&_blockquote]:border-l-2 [&_blockquote]:pl-3 [&_blockquote]:italic [&_blockquote]:opacity-90 [&_blockquote]:my-1',
  '[&_a]:underline',
  '[&_img]:rounded-lg [&_img]:max-w-[260px]',
  '[&_ul]:list-disc [&_ul]:pl-5 [&_ul]:my-1',
  '[&_ol]:list-decimal [&_ol]:pl-5 [&_ol]:my-1'
].join(' ')
